import React, { useEffect, useState } from "react";
import axios from "axios";
import "../index.css";

const Carlists = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const vehiclesPerPage = 5;
  const [editingVehicle, setEditingVehicle] = useState(null);
  const [editForm, setEditForm] = useState({ type: "", brand: "", model: "", mileage: "", rent: "" });

  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = () => {
    axios.get(`${process.env.REACT_APP_BACKEND}/api/vehicles`)
      .then(response => {
        setVehicles(response.data);
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to fetch vehicles");
        setLoading(false);
      });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this vehicle?")) {
      axios.delete(`${process.env.REACT_APP_BACKEND}/api/vehicles/${id}`)
        .then(() => {
          setVehicles(vehicles.filter(vehicle => vehicle._id !== id));
        })
        .catch(() => {
          alert("Failed to delete vehicle");
        });
    }
  };

  const handleEdit = (vehicle) => {
    setEditingVehicle(vehicle);
    setEditForm({ ...vehicle });
  };

  const handleEditChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    axios.put(`${process.env.REACT_APP_BACKEND}/api/vehicles/${editingVehicle._id}`, editForm)
      .then(() => {
        fetchVehicles();
        setEditingVehicle(null);
      })
      .catch(() => {
        alert("Failed to update vehicle");
      });
  };

  const filteredVehicles = vehicles.filter(vehicle =>
    vehicle.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
    vehicle.brand.toLowerCase().includes(searchQuery.toLowerCase()) ||
    vehicle.model.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastVehicle = currentPage * vehiclesPerPage;
  const indexOfFirstVehicle = indexOfLastVehicle - vehiclesPerPage;
  const currentVehicles = filteredVehicles.slice(indexOfFirstVehicle, indexOfLastVehicle);

  const totalPages = Math.ceil(filteredVehicles.length / vehiclesPerPage);

  if (loading) return <p className="text-center mt-4">Loading vehicles...</p>;
  if (error) return <p className="text-danger text-center">{error}</p>;

  return (
    <div className="vehicle-list-container container mt-4">
      <h2 className="vehicle-list-title text-center mb-4">Vehicle List</h2>

      <input
        type="text"
        className="vehicle-search-input form-control mb-3"
        placeholder="Search by type, brand, or model..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      <div className="table-responsive">
        <table className="vehicle-table table table-striped table-bordered table-hover">
          <thead className="vehicle-table-head">
            <tr>
              <th>#</th>
              <th>Type</th>
              <th>Brand</th>
              <th>Model</th>
              <th>Mileage</th>
              <th>Rent price</th>
              <th>Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentVehicles.map((vehicle, index) => (
              <tr key={vehicle._id}>
                <td>{indexOfFirstVehicle + index + 1}</td>
                <td>{vehicle.type}</td>
                <td>{vehicle.brand}</td>
                <td>{vehicle.model}</td>
                <td>{vehicle.mileage}</td>
                <td>{vehicle.rent}</td>
                <td>
                  <img
                    src={`${process.env.REACT_APP_BACKEND}${vehicle.image}`}
                    alt={vehicle.model}
                    className="vehicle-image img-fluid rounded"
                  />
                </td>
                <td>
                  <button className="btn btn-warning btn-sm mr-2" onClick={() => handleEdit(vehicle)}>
                    Edit
                  </button>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDelete(vehicle._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-3">
        <button className="btn btn-primary" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
          Previous
        </button>
        <span>Page {currentPage} of {totalPages}</span>
        <button className="btn btn-primary" disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
          Next
        </button>
      </div>

      {editingVehicle && (
          <>
            <div className="edit-vehicle-modal-overlay" onClick={() => setEditingVehicle(null)}></div>
            <div className="edit-vehicle-modal">
              <div className="edit-vehicle-modal-header">
                <h3>Edit Vehicle</h3>
                <button className="edit-vehicle-modal-close" onClick={() => setEditingVehicle(null)}>&times;</button>
              </div>
              <form className="edit-vehicle-form" onSubmit={handleEditSubmit}>
                <div className="edit-vehicle-form-group">
                  <label htmlFor="type">Type</label>
                  <input type="text" id="type" name="type" value={editForm.type} onChange={handleEditChange} placeholder="Type" required />
                </div>
                <div className="edit-vehicle-form-group">
                  <label htmlFor="brand">Brand</label>
                  <input type="text" id="brand" name="brand" value={editForm.brand} onChange={handleEditChange} placeholder="Brand" required />
                </div>
                <div className="edit-vehicle-form-group">
                  <label htmlFor="model">Model</label>
                  <input type="text" id="model" name="model" value={editForm.model} onChange={handleEditChange} placeholder="Model" required />
                </div>
                <div className="edit-vehicle-form-group">
                  <label htmlFor="mileage">Mileage</label>
                  <input type="text" id="mileage" name="mileage" value={editForm.mileage} onChange={handleEditChange} placeholder="Mileage" required />
                </div>
                <div className="edit-vehicle-form-group">
                  <label htmlFor="rent">Rent</label>
                  <input type="text" id="rent" name="rent" value={editForm.rent} onChange={handleEditChange} placeholder="Rent" required />
                </div>
                <div className="edit-vehicle-modal-actions">
                  <button type="submit" className="edit-vehicle-save-btn">Save</button>
                  <button type="button" className="edit-vehicle-cancel-btn" onClick={() => setEditingVehicle(null)}>Cancel</button>
                </div>
              </form>
            </div>
          </>
      )}
    </div>
  );
};

export default Carlists;
